
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({ name: 'PinCodeDisplay' })
export default class PinCodeDisplay extends Vue {
  @Prop({ required: true })
  code!: string;

  @Prop({ default: 'md' })
  size!: 'sm' | 'md' | 'lg';

  @Prop({ default: 'active' })
  variant!: 'active' | 'inactive';
}
